/* Capture Kaching's documented selection event before the app widget hydrates. */
(function (scope) {
  'use strict';
  const normalize = (detail, baseVariantId) => {
    if (!Array.isArray(detail?.variantIdQuantities) || detail.variantIdQuantities.length !== 1) return null;
    const line = detail.variantIdQuantities[0];
    const id = Number(line.variantId ?? line.variantID ?? line.variant_id ?? line.id);
    const quantity = Number(line.quantity);
    if (id !== Number(baseVariantId) || ![1, 2, 3].includes(quantity)) return null;
    return { id, quantity };
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = { normalize }; return; }
  let detail = scope.gnagfriKachingSelection || null;
  scope.GnagfriKaching = { normalize, get detail() { return detail; } };
  document.addEventListener('variants-changed', event => {
    if (!event.target.closest?.('[data-gnagfri-kaching]')) return;
    detail = event.detail;
    document.dispatchEvent(new CustomEvent('gnagfri:bundle-selection', { detail }));
  }, true);
})(typeof window === 'undefined' ? globalThis : window);
